import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseconfig';

export const fetchUsers = async () => {
  try {
    const usersQuery = collection(db, 'users');
    const querySnapshot = await getDocs(usersQuery);
    const usersData = {};
    querySnapshot.forEach((doc) => {
      const userData = doc.data();
      usersData[userData.email] = userData.name;
    });
    return usersData;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {};
  }
};

